var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cms)?_c('div',{staticClass:"homeRoot",class:{ isStatic: _vm.introMode === 'static' }},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullScreenCenter"},[_c('div',{staticClass:"sectionInner sectionNarrow"},[_c('div',{staticClass:"eyebrow"},[_vm._v("Silver Bullet"),_c('sup',[_vm._v("®")])]),_c('h1',{staticClass:"brandHeadline"},[_vm._v(" Under Construction ")])])])
}]

export { render, staticRenderFns }